import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getSubsidies } from '../../../../api/subsidy/queries/getSubsidies';
import { ISubsidy } from '../../../../interfaces/Subsidy.interfaces';

export const useGetSubsidiesQuery = () => {
  return useQuery<ISubsidy[], AxiosError>(
    ['subsidies'],
    () => {
      // Fetch all subsidies at once by not providing searchParam (or providing empty)
      // Backend should be updated to return all when no pagination is provided.
      return getSubsidies({});
    },
    {
      retry: 0,
    },
  );
};
